import { Component } from '@angular/core';
import { AbstractDialogComponent } from '../abstract-dialog-component.directive';
import { SolText } from '../../../models/core/sol-text';
import { SolDialogType } from '../../../models/core/sol-dialog';
import { SolDialogComponent } from '../sol-dialog/sol-dialog.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { SolInfoDialogState } from './sol-info-dialog.state';

@Component({
  selector: 'sol-info-dialog',
  imports: [SolDialogComponent, TranslatePipe],
  templateUrl: './sol-info-dialog.component.html',
})
export class SolInfoDialogComponent extends AbstractDialogComponent<SolInfoDialogState> {
  protected readonly dialog$ = this.compute(state => state.dialog);
  protected readonly text$ = this.compute(state => state.text);

  constructor() {
    super(SolInfoDialogState.of());
  }

  public configure(title: SolText, text: SolText, type?: SolDialogType): void {
    this.update(s => s.withConfig(title, text, type));
  }

  public showErrors(): void {
    // Info dialogs have no error handling — close button only.
  }

  protected handleConfirm(): void {
    // Info dialogs have no confirm button — close button only.
  }
}
